// extracted by mini-css-extract-plugin
export default {"container":"PublicMapScreen_container__pKnhC","col":"PublicMapScreen_col__LijCs","button":"PublicMapScreen_button__P6GTL"};